import CheckoutPanel from 'checkout/components/CheckoutPanel'
import { useCheckoutContext } from 'checkout/containers/CheckoutContextProvider'
import { IError } from 'errors/types/IError'
import { t } from 'localization'
import CreateAccountForm from 'login/components/CreateAccountForm'
import LoginForm from 'login/components/LoginForm'
import { CheckoutQA } from 'shared/dataAttributes'
import UserSummary from './UserSummary'

const TP = 'checkout.components.AuthPanel.Auth'

// TODO: Remove? This code is unreachable due to the FF temp_web_fc_guest_checkout which
// has not been updated since 2022-0217. See /src/checkout/components/AuthPanel/AuthPanel.tsx
// and original PR https://github.com/goatapp/flightclub.com/pull/935

const Auth = () => {
  const {
    createOrder,
    updatePanel,
    panels: { auth },
  } = useCheckoutContext()

  const handleError = (errors: [IError]) =>
    updatePanel('auth', { loading: false, error: errors?.[0]?.message || errors?.[0] })

  const handleCreateAccountClick = () => {
    updatePanel('auth', { loading: false, view: 'createAccount', isEditing: true, complete: false })
  }

  const handleLoginClick = () => {
    updatePanel('auth', { loading: false, view: 'login', isEditing: true, complete: false })
  }

  return (
    <CheckoutPanel
      editable={false}
      expandedContent={
        auth.view === 'login' ? (
          <LoginForm
            onCreateAccountClick={handleCreateAccountClick}
            onLogin={createOrder}
            onLoginError={handleError}
          />
        ) : (
          <CreateAccountForm
            onLoginClick={handleLoginClick}
            onCreateAccount={createOrder}
            onCreateAccountError={handleError}
            loginInsteadStyle="button"
          />
        )
      }
      name="auth"
      qaAttr={CheckoutQA.LoginCreateAccount}
      summarizedContent={<UserSummary />}
      title={
        auth.complete
          ? t(`${TP}.loggedIn`, 'logged in')
          : auth.view === 'login'
          ? t(`${TP}.logInToCheckout`, 'login to checkout')
          : auth.view === 'createAccount'
          ? t(`${TP}.createAnAccount`, 'create an account')
          : ''
      }
    />
  )
}

export default Auth
